var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "hoverfill",
    cx: 25,
    cy: 25,
    r: 25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "content",
    d: "M37.3539 14.6847L33.122 35.0173C32.8094 36.4429 31.9197 36.8053 30.7896 36.1287L24.3333 31.2962L21.2075 34.3407C21.055 34.541 20.8584 34.7031 20.6331 34.8142C20.4078 34.9254 20.16 34.9825 19.909 34.981L20.3658 28.2881L32.3885 17.2822C32.9055 16.811 32.2683 16.5573 31.571 17.0284L16.759 26.5001L10.387 24.4704C9.00443 24.0355 8.98039 23.069 10.6756 22.3925L35.6347 12.6309C36.837 12.1839 37.7987 12.8847 37.4141 14.6847H37.3539Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.be1633eac45cce75e0cdcaf007b880af.svg";
export { ForwardRef as ReactComponent };